import { CLOUDFLARE_ENVIRONMENT } from '../cloudflareEnvvars';

export const isProdEnv = (): boolean => CLOUDFLARE_ENVIRONMENT === 'prod';
export const isDevEnv = (): boolean => CLOUDFLARE_ENVIRONMENT === 'dev';
export const isStagingEnv = (): boolean => CLOUDFLARE_ENVIRONMENT === 'staging';
